(() => {
  const STORAGE_KEY = 'anekanta-b2b-selected-product-v2';

  const clean = (value) => (value || '').toString().trim();
  const same = (a, b) => clean(a).toLocaleLowerCase() === clean(b).toLocaleLowerCase();

  const readStored = () => {
    try {
      const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
      if (!parsed || !parsed.product) return null;
      if (parsed.savedAt && Date.now() - parsed.savedAt > 30 * 60 * 1000) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  };

  const readPayload = () => {
    const params = new URLSearchParams(window.location.search);
    const fromUrl = {
      product: clean(params.get('product')),
      botanical: clean(params.get('botanical')),
      common: clean(params.get('common')),
      form: clean(params.get('form')),
      source: clean(params.get('source')),
      savedAt: Date.now()
    };
    return fromUrl.product ? fromUrl : (readStored() || fromUrl);
  };

  const init = (section) => {
    if (!section || section.dataset.aoReady === 'true') return;

    const payload = readPayload();
    const select = section.querySelector('[data-ao-product-select]');
    const clickedOption = section.querySelector('[data-ao-clicked-product]');
    const otherOption = section.querySelector('[data-ao-other-option]');
    const otherInput = section.querySelector('[data-ao-other-input]');
    const title = section.querySelector('[data-ao-selected-title]');
    const meta = section.querySelector('[data-ao-selected-meta]');
    const botanicalInput = section.querySelector('[data-ao-hidden-botanical]');
    const commonInput = section.querySelector('[data-ao-hidden-common]');
    const formInput = section.querySelector('[data-ao-hidden-form]');
    const sourceInput = section.querySelector('[data-ao-hidden-source]');
    if (!select) return;

    const defaultTitle = title?.dataset.emptyText || title?.textContent || 'No product selected';

    const findProductOption = (product) => Array.from(select.options).find((option) => {
      if (!option.value || option === clickedOption || option === otherOption) return false;
      return same(option.value, product);
    });

    if (payload.product) {
      let matched = findProductOption(payload.product);
      if (!matched && clickedOption) {
        clickedOption.value = payload.product;
        clickedOption.textContent = payload.product;
        clickedOption.dataset.botanical = payload.botanical;
        clickedOption.dataset.common = payload.common;
        clickedOption.dataset.form = payload.form;
        clickedOption.hidden = false;
        matched = clickedOption;
      }
      if (matched) {
        if (payload.botanical) matched.dataset.botanical = payload.botanical;
        if (payload.common) matched.dataset.common = payload.common;
        if (payload.form) matched.dataset.form = payload.form;
        select.value = matched.value;
      }
    }

    const renderSummary = () => {
      const option = select.options[select.selectedIndex];
      const value = clean(select.value);
      const isOther = Boolean(otherOption && option === otherOption);
      const hasProduct = Boolean(value && !isOther);
      const botanical = hasProduct ? clean(option?.dataset.botanical) : '';
      const common = hasProduct ? clean(option?.dataset.common) : '';
      const productForm = hasProduct ? clean(option?.dataset.form) : '';

      if (title) title.textContent = hasProduct ? value : (isOther ? clean(otherOption.textContent) : defaultTitle);

      const bits = [];
      if (botanical) bits.push(`Botanical Name: ${botanical}`);
      if (common) bits.push(`Common Name: ${common}`);
      if (productForm) bits.push(`Form: ${productForm}`);
      if (meta) {
        meta.textContent = bits.join('  •  ');
        meta.hidden = bits.length === 0;
      }

      if (otherInput) otherInput.required = isOther;
      if (botanicalInput) botanicalInput.value = botanical;
      if (commonInput) commonInput.value = common;
      if (formInput) formInput.value = productForm;
      if (sourceInput) sourceInput.value = payload.source || document.referrer || window.location.href;
    };

    select.addEventListener('change', renderSummary);
    renderSummary();
    section.dataset.aoReady = 'true';
  };

  const initAll = (root = document) => root.querySelectorAll('[data-ao-enquiry]').forEach(init);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
